import React, { useState } from 'react';
import axios from 'axios';

const Dealership = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    business_name: '',
    experience: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await axios.post('/api/dealership', formData);
      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting dealership form:', error);
    }
  };

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Become a Janvahan Dealer</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Join India's fastest-growing electric vehicle network and be part of the green revolution
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Benefits Section */}
          <div>
            <h2 className="text-3xl font-bold mb-6">Why Partner With Us?</h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="bg-red-100 rounded-full p-3 mr-4">
                  <span className="text-2xl">💰</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">High Profit Margins</h3>
                  <p className="text-gray-600">Enjoy industry-leading profit margins and exclusive dealer benefits</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-red-100 rounded-full p-3 mr-4">
                  <span className="text-2xl">🚀</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Growing Market</h3>
                  <p className="text-gray-600">Tap into India's rapidly growing electric vehicle market</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-red-100 rounded-full p-3 mr-4">
                  <span className="text-2xl">🎓</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Training & Support</h3>
                  <p className="text-gray-600">Comprehensive training programs and 24/7 dealer support</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-red-100 rounded-full p-3 mr-4">
                  <span className="text-2xl">📈</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Marketing Support</h3>
                  <p className="text-gray-600">National and local marketing campaigns to drive customers</p>
                </div>
              </div>
            </div>
          </div>

          {/* Application Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-6">Apply Now</h2>
            {submitted ? (
              <div className="text-center py-8">
                <div className="text-6xl mb-4">🎉</div>
                <h3 className="text-2xl font-bold mb-2">Application Submitted!</h3>
                <p className="text-gray-600">Our team will contact you within 48 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name *"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number *"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                />
                <input
                  type="text"
                  name="city"
                  placeholder="City *"
                  required
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                />
                <input
                  type="text"
                  name="business_name"
                  placeholder="Business Name"
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                />
                <select
                  name="experience"
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                >
                  <option value="">Years of Experience in Automotive</option>
                  <option value="0-2">0-2 years</option>
                  <option value="3-5">3-5 years</option>
                  <option value="6-10">6-10 years</option>
                  <option value="10+">10+ years</option>
                </select>
                <textarea
                  name="message"
                  placeholder="Additional Information"
                  rows="4"
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                ></textarea>
                <button
                  type="submit"
                  className="w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition"
                >
                  Submit Application
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dealership;